import React from 'react';
import { Link } from 'react-router-dom';

import iF_badge from '../assets/images/iF_social_impact_badge.png';
import logo from '../assets/images/logo.jpg';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-8">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <div className="w-18 h-18 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-2xl overflow-hidden flex items-center justify-center mr-4">
                <img 
                    src={logo}
                    alt="Company Logo" 
                    className="h-16 sm:h-20 w-auto transition-all duration-300 hover:opacity-90" // Responsive height
                />
              </div>
              <div>
                <h2 className="text-2xl font-bold">WealthyCats</h2>
                <p className="text-gray-400 text-sm">Play to Build Financial Resilience</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              A registered social enterprise creating playful financial education tools for children in Thailand. Making financial literacy accessible, joyful, and sustainable.
            </p>
            {/* iF Award Badge */}
            <div className="w-24 h-10 mr-2">
                  <img 
                    src={iF_badge} 
                    alt="iF Social Impact Award" 
                    className="w-full h-full object-contain"
                  />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#FED700]">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#FED700] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/academy" className="text-gray-400 hover:text-[#FED700] transition-colors">
                  Academy
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-[#FED700] transition-colors">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/tools" className="text-gray-400 hover:text-[#FED700] transition-colors">
                  Financial Planning Tools
                </Link>
              </li>
              <li>
                <Link to="/organization/about" className="text-gray-400 hover:text-[#FED700] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#FED700] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#FED700]">Contact Us</h3>
            <ul className="space-y-4">

              <li className="flex items-start">
                <svg className="w-5 h-5 text-[#FFFFFF] mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-gray-400">Bangkok, Thailand</span>
              </li>

              <li className="flex items-start">
                <svg className="w-5 h-5 text-[#FFFFFF] mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-gray-400">win@hacademyasia.com</span>
              </li>

              <li className="flex items-start">
                <svg className="w-5 h-5 text-[#FFFFFF] mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="text-gray-400">+66 99-464-5592</span>
              </li>

              <li className="flex items-start">
                <svg className="w-5 h-5 text-[#FFFFFF] mr-3 mt-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                <a
                    href="https://www.facebook.com/profile.php?id=61563842891479"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-gray-400 hover:text-[#FED700] transition-colors"
                >
                <span>Facebook page</span>
                </a>
             </li>

             <li className="flex items-start">
                <svg className="w-5 h-5 text-[#FFFFFF] mr-3 mt-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a2.999 2.999 0 00-2.112-2.122C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.386.564A2.999 2.999 0 00.502 6.186 31.5 31.5 0 000 12a31.5 31.5 0 00.502 5.814 2.999 2.999 0 002.112 2.122C4.495 20.5 12 20.5 12 20.5s7.505 0 9.386-.564a2.999 2.999 0 002.112-2.122A31.5 31.5 0 0024 12a31.5 31.5 0 00-.502-5.814zM9.75 15.5v-7l6 3.5-6 3.5z" />
                </svg>
                <a
                    href="https://www.youtube.com/@WealthyCats"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-gray-400 hover:text-[#FED700] transition-colors"
                >
                <span>Youtube channel</span>
                </a>
             </li>

            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-500 text-sm">
                &copy; {new Date().getFullYear()} WealthyCats by Team H Is Happy Company Limited. All rights reserved.
              </p>
              <p className="text-gray-600 text-xs mt-1">
                Registered Social Enterprise • Bangkok, Thailand
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
